import { useTranslation } from "../../hooks/useTranslation";
import { Title } from "../../components/ui/title";
import { Tile } from "../../components/ui/tile";
import { Education } from "./content/model";
import { useLanguage } from "../../hooks/useLanguage";
import { useLocation, LOCATIONS } from "../../hooks/useLocation";

import styles from "./index.module.scss";

import frenchJson from './content/fr.json';
import englishJson from './content/en.json';

interface FormationProps {
    id?: string;
}

export const Formation = ({ id }: FormationProps) => {
    const { t } = useTranslation();
    const { language } = useLanguage();
    const { setLocation } = useLocation();

    const content: Education[] = language === 'fr' ? (frenchJson as Education[]) : (englishJson as Education[]);

    // Fonction pour parser la location et retourner le code pays
    const parseLocation = (location: string): LOCATIONS | null => {
        if(/france/i.test(location) && /canada/i.test(location)) return LOCATIONS.CANADA_AND_FRANCE;
        if (/france/i.test(location)) return LOCATIONS.FRANCE;
        if (/canada/i.test(location)) return LOCATIONS.CANADA;
        if (/worldwide/i.test(location)) return LOCATIONS.WORLDWIDE;
        return null;
    };

    return (
        <div className={styles.formation} id={id}>
            <Title>{t("header.education")}</Title>
            <div className={styles.tiles}>
                {content.map((education, index) => (
                    <Tile
                        key={index}
                        title={education.title}
                        description={education.institution}
                        subDescription={education.location}
                        date={education.date}
                        onMouseEnter={() => {
                            const loc = parseLocation(education.location);
                            if (loc) setLocation(loc);
                        }}
                        onMouseLeave={() => setLocation(null)}
                    />
                ))}
            </div>
        </div>
    );
}